import { render } from "./BaseButton.vue?vue&type=template&id=3d3ad0e2&scoped=true&ts=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=3d3ad0e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d3ad0e2"]])

export default __exports__